import { SHARED_PATIENT_ASSISTANCE_BUSINESS_FLOW_CASE_INITIAL_STATE } from '@libs/shared/domain/patient-assistance/business-flow/case/shared-patient-assistance-business-flow-case-initial-state';

export const INITIAL_STATE = SHARED_PATIENT_ASSISTANCE_BUSINESS_FLOW_CASE_INITIAL_STATE;
export const INITIAL_INFO_LOADED_STATE = 'InitialInfoLoaded';
export const PHARMACY_INITIATED_STATE = 'PharmacyInitiated';
export const PATIENT_INITIATED_STATE = 'PatientInitiated';
export const WAITING_FOR_PHARMACY_STATE = 'WaitingForPharmacy';
export const WAITING_FOR_PATIENT_STATE = 'WaitingForPatient';
export const COMPLETED_STATE = 'Completed';
export const ARCHIVED_STATE = 'Archived';

export const SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_PROCESS_STATES = [
  INITIAL_STATE,
  INITIAL_INFO_LOADED_STATE,
  PHARMACY_INITIATED_STATE,
  PATIENT_INITIATED_STATE,
  WAITING_FOR_PHARMACY_STATE,
  WAITING_FOR_PATIENT_STATE,
  COMPLETED_STATE,
  ARCHIVED_STATE,
] as const;

export type SharedBusinessFlowProcessFlowCustomerSupportProcessStateType =
  (typeof SHARED_BUSINESS_FLOW_PROCESS_FLOW_CUSTOMER_SUPPORT_PROCESS_STATES)[number];
